module.exports = __webpack_public_path__ + "images/bull-tile-background@2x_9535a93.png";